var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(1 ==2)?_c('div',[(_vm.showFlag)?_c('button',{staticClass:"ml-3 mt-3",on:{"click":_vm.openSide}},[_c('v-icon',{attrs:{"size":"28"}},[_vm._v("fas fa-bars")])],1):_vm._e()]):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }